import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  ViewOfferPwaQueryQuery,
  ViewOfferPwaQueryQueryVariables
} from "../../../schemaTypes";

export const viewOfferPWAQuery = gql`
  query ViewOfferPWAQuery($id: String!) {
    viewOfferPWA(id: $id) {
      id
      title
      description
      bannerUrl
      # category {
      #   id
      #   name
      #   imgSrc
      #   createdAt
      #   # updatedAt
      # }
      offerType
      amount
      status
      # discountType
      # discountValue
      # partnerVoucher
      # referralUrl
      offerTOR
      startDate
      endDate
      # community{
      #   id
      #   name
      #   alias
      # }
      # location{
      #   id
      #   city
      # }
      createdBy{
        id
        admin {
          id
          merchantProfile {
            id
            # address
            # city
            # country
            # postcode
            companyName
            username
            # industry {
            #   id
            #   name
            # }
            companyLocation
            logoUrl
            bannerUrl
            description
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export interface WithViewOfferPWA {
  offer: ViewOfferPwaQueryQuery['viewOfferPWA'] | null;
  loading: boolean;
}

interface Props {
  offerId: string;
  children: (data: WithViewOfferPWA) => React.ReactElement | null;
}

export const ViewOfferPWA: React.FC<Props> = ({ offerId, children }) => {
  const { data, loading } = useQuery<
    ViewOfferPwaQueryQuery, 
    ViewOfferPwaQueryQueryVariables
  >(viewOfferPWAQuery, {
    variables: { id: offerId }
  });

  let offer: ViewOfferPwaQueryQuery['viewOfferPWA'] | null = null;
  if (data && data.viewOfferPWA) {
    offer = data.viewOfferPWA;
  }

  return children({
    offer,
    loading
  });
};